import api from "api/api";

export const createSyntec = async (data) =>
  await api.post("/settings/syntec", data);

export const getSyntecList = async () => await api.get("/settings/syntec");

export const getSyntecById = async (id) =>
  await api.get(`/settings/syntec/${id}`);

export const updateSyntecById = async (id, data) =>
  await api.put(`/settings/syntec/${id}`, data);

export const deleteSyntecById = async (id) =>
  await api.delete(`/settings/syntec/${id}`);

export const getSyntecCoefById = async (id) =>
  await api.get(`/settings/syntec_coef/${id}`);

export const updateSyntecCoefById = async (id, data) =>
  await api.put(`/settings/syntec_coef/${id}`, data);

export const createSyntecCoef = async (data) =>
  await api.post("/settings/syntec_coef", data);

export const deleteSyntecCoefById = async (id) =>
  await api.delete(`/settings/syntec_coef/${id}`);

export const getSyntecCoefList = async () =>
  await api.get("/settings/syntec_coef");

export const updateSyntecCoefStaffById = async (id, data) =>
  await api.put(`/settings/syntec_coef_staff/${id}`, data);

export const createSyntecCoefStaff = async (data) =>
  await api.post("/settings/syntec_coef_staff", data);

export const deleteSyntecCoefStaffById = async (id) =>
  await api.delete(`/settings/syntec_coef_staff/${id}`);

export const getSyntecCoefStaffById = async ({ id }) =>
  await api.get(`/settings/syntec_coef_staff/${id}`);

export const getSyntecCoefStaffList = async () =>
  await api.get("/settings/syntec_coef_staff");
